import { ROUTES } from '../../const/routes';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

const LogoGrande = () => {
  const navigate = useNavigate();
  const { userData } = useUser();

  const handleLogoClick = () => {
    if (userData) {
      // Si el usuario está autenticado, lo redirigimos a 'juegos'
      navigate(ROUTES.listaJuegos);
    } else {
      // Si no está autenticado, lo redirigimos a 'inicio'
      navigate(ROUTES.inicio);
    }
  };

  return (
    <img
      src={ROUTES.rutaLogos + 'CasinoPrint04Resized.gif'}
      alt="Logo Casino Print"
      className="h-24 sm:h-28 md:h-32 lg:h-36 cursor-pointer drop-shadow-[0_0_20px_rgba(148,0,211,0.7)] transition-all duration-300 ease-in-out hover:drop-shadow-[0_0_30px_rgba(148,0,211,0.9)]"
      onClick={handleLogoClick} // Evento de clic que verifica el estado de autenticación
    />
  );
};

export default LogoGrande;
